enum SnackbarSeverity {
  INFO = 'info',
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export default SnackbarSeverity;
